import React, { FC } from 'react'
import { Typography, TextField as MuiTextField, TextFieldProps, Box } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { FormControl } from './styles/textField.styles'
import theme from 'theme'

const muiTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            WebkitBackgroundClip: 'text !important',
            WebkitTextFillColor: theme.baseColors.greyscale[80],
            opacity: 1
          },
          '&::placeholder': {
            overflow: 'hidden',
            color: `${theme.baseColors.secondary[80]} !important`,
            WebkitTextFillColor: `${theme.baseColors.secondary[80]} !important`,
            textOverflow: 'ellipsis',
            fontSize: theme.typography.fontSize.xLarge,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.normal,
            lineHeight: 'normal',
            opacity: '1 !important'
          }
        },
        root: {
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.errorLight
          }
        }
      }
    }
  }
})

type Props = TextFieldProps & {
  name: string
  label: string
  helperText?: string
  variant?: 'standard' | 'outlined' | 'filled'
  counterLimit?: number
  value: string | number
  onChange: any
}

const TextField: FC<Props> = ({ label, variant, helperText, counterLimit, value, onChange, placeholder, ...rest }) => {
  const hasError = Boolean(helperText)
  const isOverLimit = counterLimit && typeof value === 'string' ? value.length > counterLimit : false

  return (
    <ThemeProvider theme={muiTheme}>
      <FormControl
        variant={variant || 'standard'}
        className="text-field-custom-label-form-control"
        iserrored={hasError ? 'true' : 'false'}
      >
        <MuiTextField
          value={value}
          error={hasError}
          label={label}
          onChange={onChange}
          type={rest.type}
          {...rest}
          rows={rest.multiline ? 4 : 0}
          InputLabelProps={{
            shrink: true,
            ...rest.InputLabelProps
          }}
          inputProps={{
            placeholder,
            ...rest.inputProps
          }}
        />
        {helperText && <Typography className={`helper-text ${hasError ? 'error-text' : ''}`}>{helperText}</Typography>}
        {typeof counterLimit !== 'undefined' && typeof value === 'string' && (
          <Box className="char-counter">
            <Typography className={`char-counter-text ${isOverLimit ? 'text-danger' : ''}`}>
              {value.length}/{counterLimit}
            </Typography>
          </Box>
        )}
      </FormControl>
    </ThemeProvider>
  )
}

export default TextField
